module.exports = __webpack_public_path__ + "static/media/arrow-right.f1e31363.svg";